import { render, staticRenderFns } from "./PairsPage.vue?vue&type=template&id=3eea24bc&scoped=true&"
import script from "./PairsPage.vue?vue&type=script&lang=js&"
export * from "./PairsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eea24bc",
  null
  
)

export default component.exports